'use client';

interface SegmentedControlProps {
    label: string;
    options: string[];
    value: string;
    onChange: (value: string) => void;
}

export default function SegmentedControl({
    label,
    options,
    value,
    onChange,
}: SegmentedControlProps) {
    return (
        <div className="flex flex-col gap-2">
            <label className="text-[11px] font-medium uppercase tracking-[0.05em] text-muted">
                {label}
            </label>
            <div className="flex gap-0.5 rounded-sm border-[0.5px] border-line bg-surface p-[3px]">
                {options.map((opt) => (
                    <button
                        key={opt}
                        onClick={() => onChange(opt)}
                        className={`flex-1 rounded-[4px] border-[0.5px] py-1 text-[13px] transition-all duration-100 ${
                            value === opt
                                ? 'border-line bg-page font-semibold text-ink'
                                : 'border-transparent font-normal text-hint'
                        }`}
                    >
                        {opt}
                    </button>
                ))}
            </div>
        </div>
    );
}
